// The brand's own social profiles are defined in `common-universal` because they are also published
// as `Organization.sameAs` by properties with no React runtime; they are re-exported here so UI code
// keeps reaching every site link through one namespace.
export {
  discordHref,
  douyinHref,
  instagramHref,
  linkedinHref,
  redNoteHref,
  threadsHref,
  tiktokHref,
  youtubeHref
} from 'notability-services-common-universal'

export const appStoreHref = 'https://apps.apple.com/app/notability/id360593530'
export const playStoreHref = 'https://play.google.com/store/apps/details?id=com.gingerlabs.notability'

// The marketing apps (download) page. Root-relative, so it resolves same-origin from the web app and
// the login pages too (the nginx `location /apps` block proxies it to marketing). It resolves
// artifact URLs server-side, so it is also every other surface's fallback: those read the releases
// bucket from script, which only works where the bucket's `cors` block has been applied.
export const appsPageHref = '/apps'
export const blogHref = 'https://blog.notability.com'
export const careersHref = 'https://jobs.gingerlabs.com'
export const supportHref = 'https://support.gingerlabs.com'
export const twitterHref = 'https://twitter.com/notabilityapp'
export const facebookHref = 'https://facebook.com/notabilityapp'
export const twobirdHref = 'https://twobird.com'
export const eduApplicationHref =
  'https://support.gingerlabs.com/hc/en-us/articles/5494994479642-Notability-for-Organizations'
export const templateLearnMoreHref = 'https://support.gingerlabs.com/hc/en-us/articles/227864627-Custom-Templates'
export const businessMeetingCalendarHref = 'https://calendly.com/d/ctwg-zc5-n6z/notability-for-business'
